.avatar-container {
    position: relative;
    background-color: var(--white);
    border: 6px solid var(--white);
    border-radius: 100px;
    z-index: 5;
    width: 72px;
    height: 72px;
    overflow: visible;
}

.upload-button {
    position: absolute;
    top: -6px;
    right: -6px;
    bottom: -6px;
    left: -6px;
    border: none;
    border-radius: 100px;
    padding: 0;
    background: transparent;
    cursor: pointer;
    z-index: 10;
}

.upload-overlay {
    position: absolute;
    inset: 6px;
    border-radius: 100px;
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 120ms ease-in-out;
}

.upload-overlay--contact {
    background-color: color-mix(in srgb, var(--blue) 60%, transparent);
}

.upload-overlay--account {
    background-color: color-mix(in srgb, var(--company) 60%, transparent);
}

.remove-button {
    position: absolute;
    top: -8px;
    right: -2px;
    width: 28px;
    height: 28px;
    border: 3px solid var(--white);
    border-radius: 100px;
    background-color: var(--rose);
    cursor: pointer;
    padding: 0;
    z-index: 12;
    opacity: 0;
    pointer-events: none;
    transition: opacity 120ms ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
}

.remove-button:hover {
    background-color: var(--rose-dk);
}

.remove-button-icon {
    margin-left: 0.4px;
    margin-top: 4px;
}

.avatar-container:hover .remove-button,
.avatar-container:focus-within .remove-button {
    opacity: 1;
    pointer-events: auto;
}

.remove-button:disabled {
    cursor: default;
}

.avatar-container:hover .upload-overlay,
.avatar-container:focus-within .upload-overlay {
    opacity: 1;
}

.upload-button .upload-overlay {
    opacity: 0;
}
